<template>
<widget title="My Projects" 
	icon="fa-cubes" 
	max-height="400px" 
	:widget-spinner="widgetSpinner"
	:max-height="maxHeight" 
	header-button="fa-external-link-alt"
	v-on:headerButtonClick="$router.push('/projects')">

	<table-list
		record-name="Project"
		:fields="fields"
		:records="projects"
		:hide-record-count="true"
		:sortable="true"
		:clickable-row="true"
		edit-button-text="Open"
		id-field="slug"
		has-edit="/project/{?}/dashboard">
	</table-list>
</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"

export default {
	name: "MyProjectsWidget",
	components: {
		TableList,
		Widget
	},
	props: ["maxHeight"],
	data() {
		return {
			projects: [],
			fields: [
				{label: "#",key:"job_num"},
				{label: "Name",key:"job_name"}
			],
			widgetSpinner: false
		}
	},
	methods: {
		fetchData() {
			let vm = this

			let params = {
				filters: [
					["User.id",this.$store.userDetails.id],
					["archived !=",1]
				],
				include: [
					{
						model: "User",
						fields: ["id","slug","first_name","last_name","last_active"]
					}
				],
				fields: ["job_num","job_name"]
			}

			this.widgetSpinner = true

			this.getJSON("Job/get",params).then(response => {
				vm.projects = response.data
				vm.widgetSpinner = false
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>